<template>
  <section>
    <div class="d-flex justify-center">
      <v-progress-circular indeterminate color="primary" :size="70" v-if="loggedIn"></v-progress-circular>
    </div>

    <v-form ref="form" v-model="valid" @submit.prevent="doLogin" lazy-validation v-if="!loggedIn">
      <v-card class="elevation-4">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>LOG IN</v-toolbar-title>
          <v-spacer />
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn icon large :to="{ name: 'signup' }" v-on="on">
                <v-icon>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <span>Sign up</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear absolute indeterminate color="accent" height="7" v-if="loading"></v-progress-linear>
        <v-card-text>
          <v-alert border="left" colored-border type="error" v-if="error && error.message">
            <p>{{error.message}}</p>
            <p>Has your account been verified?</p>
            <p>Is your caps lock on?</p>
          </v-alert>

          <v-text-field
            label="Email"
            v-model="userEmail"
            name="email"
            prepend-icon="mdi-account"
            type="text"
            :rules="[(v) => !!v || 'Email is required']"
            required
          />

          <v-text-field
            label="Password"
            v-model="credentials.password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            :rules="[(v) => !!v || 'Password is required']"
            required
          />

          <v-row>
            <v-col cols="12" align="end">
              <v-btn class="ma-2" color outlined :to="{ name: 'reset' }">Forgot</v-btn>
              <v-btn class="ma-2" color="primary" type="submit" outlined :disabled="!valid">Log in</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" align="end">
              <router-link :to="{name: 'verify', query: {resend: true}}">Resend Verification</router-link>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </section>
</template>
<script>
import { apiClient } from "@/api";
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    loggedIn: false,
    loading: false,
    credentials: {
      email: "",
      password: "",
      strategy: "local",
    },
    valid: true,
    error: null,
    errors: {
      email: "",
      password: "",
      auth: "",
    },
  }),
  computed: {
    ...mapGetters("apiAuth", ["isAuthenticated"]),
    userEmail: {
      get() {
        return this.credentials.email;
      },
      set(email) {
        this.credentials.email = email.toLowerCase();
      },
    },
  },
  methods: {
    ...mapActions("apiAuth", ["authenticate", "logout"]),
    //...mapActions("botAuth", { authenticateBot: "authenticate" }),
    ...mapActions("app", ["showMessage"]),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      this.errors.server = "";
    },
    async doLogin() {
      if (!this.validate()) return;
      this.loading = true;
      try {
        let authenticate = await this.authenticate(this.credentials);
        if (
          !authenticate ||
          !authenticate.user ||
          !authenticate.user.isVerified
        ) {
          this.logout();
          this.error = new Error(
            "Your account is not yet verified. Check your email for verification email."
          );
          apiClient.emit("authentication", { event: "logged-out" });
          return;
        }
        this.showMessage({ text: "You're now logged in!", color: "green" });

        this.loading = false;
        this.loggedIn = true;

        apiClient.emit("authentication", { event: "logged-in" });
      } catch (error) {
        console.log("Login error: ", error);
        this.error = error;
        this.loading = false;
        this.loggedIn = false;
      }
    },
  },
  watch: {
    /*async isAuthenticated(isAuth) {
      if (isAuth === true) await this.$router.push({ name: "dashboard" });
    },*/
    credentials: {
      handler() {
        if (!this.valid) {
          this.resetValidation();
        }
      },
      deep: true,
    },
  },
};
</script>